import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DadosPessoaisState, Utm } from './type'

export const initialState: DadosPessoaisState = {
  cpf: '',
  dataNascimento: undefined,
  nome: '',
  email: '',
  telefone: '',
  loading: false,
  done: false,
  error: false,
  autorizaContato: false,
  politicaPrivacidade: false,
  isAutorizado: false,
  utm: {
    campaing: '',
    content: '',
    medium: '',
    source: '',
  },
}

const dadosPessoaisSlice = createSlice({
  name: 'dadosPessoais',
  initialState,
  reducers: {
    setCpf: (state, action: PayloadAction<string>) => {
      state.cpf = action.payload
    },
    setNome: (state, action: PayloadAction<string>) => {
      state.nome = action.payload
    },
    setDataNascimento: (state, action: PayloadAction<Date | undefined>) => {
      state.dataNascimento = action.payload
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    setTelefone: (state, action: PayloadAction<string>) => {
      state.telefone = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },

    setError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload
    },

    setUtm: (state, action: PayloadAction<Utm>) => {
      state.utm = action.payload
    },
    setPoliticaPrivacidade: (state, action: PayloadAction<boolean>) => {
      state.politicaPrivacidade = action.payload
    },
    setClienteAutorizaContato: (state, action: PayloadAction<boolean>) => {
      state.autorizaContato = action.payload
    },
  },
})

export const {
  setCpf,
  setDataNascimento,
  setNome,
  setEmail,
  setTelefone,
  setLoading,
  setError,
  setUtm,
  setPoliticaPrivacidade,
  setClienteAutorizaContato,
} = dadosPessoaisSlice.actions

export default dadosPessoaisSlice.reducer
